export const GOOGLE_OAUTH_SCOPES = {
    GOOGLE_DRIVE: {
        FILE: "https://www.googleapis.com/auth/drive.file",
        READONLY: "https://www.googleapis.com/auth/drive.readonly",
        FULL: "https://www.googleapis.com/auth/drive"
    },
    GOOGLE_CALENDAR: {
        CALENDAR: "https://www.googleapis.com/auth/calendar",
        CALENDAR_EVENTS: "https://www.googleapis.com/auth/calendar.events",
        CALENDAR_EVENTS_READONLY: "https://www.googleapis.com/auth/calendar.events.readonly",
        CALENDAR_READONLY: "https://www.googleapis.com/auth/calendar.readonly",
        CALENDAR_SETTINGS_READONLY: "https://www.googleapis.com/auth/calendar.settings.readonly",
    },
    GOOGLE_CLASSROOM: {
        COURSES: "https://www.googleapis.com/auth/classroom.courses",
        ROSTERS: "https://www.googleapis.com/auth/classroom.rosters",
        PROFILE_EMAILS: "https://www.googleapis.com/auth/classroom.profile.emails",
        TOPICS: "https://www.googleapis.com/auth/classroom.topics",
        COURSEWORK_ME: "https://www.googleapis.com/auth/classroom.coursework.me",
        COURSEWORK_STUDENTS: "https://www.googleapis.com/auth/classroom.coursework.students",
    },
    GMAIL: {
        READONLY: "https://www.googleapis.com/auth/gmail.readonly",
        SEND: "https://www.googleapis.com/auth/gmail.send",
        MODIFY: "https://www.googleapis.com/auth/gmail.modify",
        LABELS: "https://www.googleapis.com/auth/gmail.labels",
    },
    USERINFO_PROFILE: "https://www.googleapis.com/auth/userinfo.profile",
    ADMIN_REPORTS_AUDIT_READONLY: "https://www.googleapis.com/auth/admin.reports.audit.readonly"
};
